"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.DEFAULT_HEIGHT = exports.DISMISS_BUTTON_GAP = exports.PADDING_VERTICAL = exports.PADDING_HORIZONTAL = exports.FONT_SIZE = exports.FOREGROUND_COLOR = void 0;
var FOREGROUND_COLOR = 'neutral90';
exports.FOREGROUND_COLOR = FOREGROUND_COLOR;
var FONT_SIZE = 'T200';
exports.FONT_SIZE = FONT_SIZE;
var PADDING_HORIZONTAL = 'S200';
exports.PADDING_HORIZONTAL = PADDING_HORIZONTAL;
var PADDING_VERTICAL = 'S100';
exports.PADDING_VERTICAL = PADDING_VERTICAL;
var DISMISS_BUTTON_GAP = 'S200';
exports.DISMISS_BUTTON_GAP = DISMISS_BUTTON_GAP;
var DEFAULT_HEIGHT = 32;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
var defaultProps = {
  backgroundColor: 'neutral10',
  dismissButtonAltText: 'Remove'
};
exports.defaultProps = defaultProps;